export default __webpack_public_path__ + "static/media/close.d24159f7.svg";